import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRenderPassInfoText } from "@/components/Package/hooks/useRenderPassInfoText";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { numberFormatter, priceFormatter } from "@/lib/utils";
import { CASH_INDEX_PAGE } from "@/settings/constant";
import { Button } from "@bookips/sds";
import { useRouter } from "next/router";
import React, { useCallback, useEffect, useState } from "react";
import { PassCategory, TicketDeductionMethod } from "../../api/membership";
//TODO : 남은과업 : 추상화, 관심사 분리
export const PassItem = (param)=>{
    let { pass , handleSubscribeWarningDialog , onOpenInfo  } = param;
    const router = useRouter();
    const [isOpenSubscribeInfoModal, setIsOpenSubscribeInfoModal] = useState(false);
    const { isUnlimitedMaxPrice , isAvailableMaxPrice , isNoDiscount  } = useRenderPassInfoText({
        pass
    });
    const onOrder = useCallback((e)=>{
        e.stopPropagation();
        const { category , deductionMethod  } = pass;
        //mx-2
        mixpanelEvent("Product Detail Button Clicked", {
            "Product Categories": pass.category,
            "Product ID": pass.id,
            "Product Title": pass.title,
            "Product Price": pass.price,
            "Button UI": "Button"
        });
        if (category === PassCategory.Ticket && deductionMethod === TicketDeductionMethod.AMOUNT) {
            mixpanelEvent("Cash Sales Button Clicked", {
                position: "이용권 구매페이지",
                categories: "가격 차감 이용권 구매하기"
            });
            router.push(CASH_INDEX_PAGE);
            return;
        }
        //experts-subscribe와 solvook-subscribe의 구매 버튼 클릭시 구독정보 모달 오픈
        if (category.includes("subscribe")) {
            setIsOpenSubscribeInfoModal(true);
            return;
        }
        onOpenInfo === null || onOpenInfo === void 0 ? void 0 : onOpenInfo(pass);
    }, [
        pass,
        onOpenInfo
    ]);
    const commonProps = {
        onOrder,
        isUnlimitedMaxPrice,
        isAvailableMaxPrice,
        availableMaxPrice: pass.availableMaxPrice,
        title: pass.title,
        price: pass.price,
        originPrice: pass.originPrice,
        discountRate: pass.discountRate,
        isNoDiscount,
        period: pass.period,
        ticketType: pass.deductionMethod,
        availableCount: pass.availableCount,
        availableAmount: pass.availableAmount,
        category: pass.category
    };
    useEffect(()=>{
        if (isOpenSubscribeInfoModal) {
            mixpanelEvent("Product Detail Popup Viewed", {
                "Product Categories": pass.category,
                "Product ID": pass.id,
                "Product Title": pass.title,
                "Product Price": pass.price
            });
        }
    }, [
        isOpenSubscribeInfoModal
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: (()=>{
            switch(pass.category){
                case PassCategory.Expert:
                    return /*#__PURE__*/ _jsx(ExpertPassItem, {
                        ...commonProps,
                        pass: pass
                    });
                case PassCategory.FreePass:
                case PassCategory.Ticket:
                    return /*#__PURE__*/ _jsx(TicketPassItem, {
                        ...commonProps
                    });
                default:
                    return /*#__PURE__*/ _jsx(TicketPassItem, {
                        ...commonProps
                    });
            }
        })()
    });
};
//  이용권
const TicketPassItem = (param)=>{
    let { onOrder , isUnlimitedMaxPrice , isAvailableMaxPrice , availableMaxPrice , title , price , originPrice , discountRate , isNoDiscount , ...props } = param;
    const description = props.category === PassCategory.FreePass && props.ticketType !== TicketDeductionMethod.COUNT ? "사용범위 내 무제한" : props.ticketType === "amount" ? "".concat(priceFormatter(props.availableAmount), "원") : "".concat(props.availableCount, "회 (").concat(priceFormatter(availableMaxPrice), "원 이하 자료)");
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(PassItemLayout, {
            title: title,
            description: /*#__PURE__*/ _jsx("span", {
                className: "typo-body1 text-secondary flex items-center",
                children: "".concat(description, " / ").concat(props.period, "일 사용")
            }),
            priceInfo: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !isNoDiscount && /*#__PURE__*/ _jsxs("s", {
                        className: "typo-body2 text-gray-300 line-through max-sm:text-left",
                        children: [
                            "정가 ",
                            numberFormatter(originPrice),
                            "원"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center max-sm:items-start",
                        children: [
                            !isNoDiscount && /*#__PURE__*/ _jsxs("em", {
                                className: "typo-h6 mr-1 text-red-400 not-italic",
                                children: [
                                    discountRate,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "typo-h6 whitespace-nowrap text-right text-gray-900 max-sm:text-left",
                                children: [
                                    numberFormatter(price),
                                    "원"
                                ]
                            })
                        ]
                    })
                ]
            }),
            purchaseCTA: /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "primary",
                onClick: onOrder,
                children: "구매하기"
            }),
            onClick: onOrder
        })
    });
};
// 엑스퍼트 이용권
const ExpertPassItem = (props)=>{
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(PassItemLayout, {
            title: props.title,
            description: /*#__PURE__*/ _jsx("span", {
                className: "typo-body1 text-secondary flex items-center",
                children: "".concat(props.period, "일 사용")
            }),
            priceInfo: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !props.isNoDiscount && /*#__PURE__*/ _jsxs("s", {
                        className: "typo-body2 text-gray-300 line-through max-sm:text-left",
                        children: [
                            "정가 ",
                            numberFormatter(props.originPrice),
                            "원"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center max-sm:items-start",
                        children: [
                            !props.isNoDiscount && /*#__PURE__*/ _jsxs("em", {
                                className: "typo-h6 mr-1 text-red-400 not-italic",
                                children: [
                                    props.discountRate,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "typo-h6 whitespace-nowrap text-right text-gray-900 max-sm:text-left",
                                children: [
                                    numberFormatter(props.price),
                                    "원"
                                ]
                            })
                        ]
                    })
                ]
            }),
            purchaseCTA: /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "primary",
                onClick: (e)=>{
                    props.onOrder(e);
                },
                children: "구매하기"
            }),
            onClick: (e)=>{
                props.onOrder(e);
            }
        })
    });
};
// 아이템 Row 레이아웃
const PassItemLayout = (param)=>{
    let { priceInfo , onClick , purchaseCTA , description , title  } = param;
    return /*#__PURE__*/ _jsx("li", {
        className: "relative cursor-pointer rounded-md border border-gray-200 bg-white p-6 transition-shadow duration-300 hover:shadow-[0px_2px_8px_rgba(0,0,0,0.08),0px_1px_4px_rgba(0,0,0,0.04)] max-sm:p-5",
        role: "button",
        onClick: onClick,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex w-full flex-nowrap items-center justify-between gap-10 max-sm:flex-col max-sm:items-stretch",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex-1 cursor-pointer",
                    children: [
                        /*#__PURE__*/ _jsx("h5", {
                            className: "typo-h6 mb-1 line-clamp-2 max-w-[380px] break-keep text-gray-700 max-sm:flex max-sm:flex-col-reverse max-sm:items-start",
                            children: title
                        }),
                        description
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex h-[52px] flex-row items-center justify-between text-right max-sm:items-end",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "mr-6 flex h-full flex-col justify-center max-sm:justify-end",
                            children: priceInfo
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex flex-col",
                            children: purchaseCTA
                        })
                    ]
                })
            ]
        })
    });
};
